<template>
    <div class="outbox">
        <div class="imgbox"
            :style="{ 'margin-left': this.left, 'width': this.width, 'height': this.height, 'max-height': this.maxHeight, 'scale': this.scale }">
            <img class="hov" :src="this.srchover" :srcset='this.srcsethover + " 2x"' alt="">
            <img class="nom" :src='this.src' :srcset='this.srcset + " 2x"' alt="">
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'src',
        'srcset',
        'srchover',
        'srcsethover',
        'width',
        'height',
        'left',
        'maxHeight', 'scale'

    ],
    data() {
        return {

        }
    },
    methods() {

    }
}
</script>
<style lang="scss" scoped>
.outbox {
    position: relative;

}

.imgbox {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;

    .nom {
        transition: opacity 0.4s ease;
        opacity: 1;
    }

    .hov {
        position: absolute;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.4s ease;
    }

    &:hover {
        .nom {
            opacity: 1;
        }

        .hov {
            opacity: 1;
            position: absolute;
            cursor: pointer;
        }
    }
}
</style>